<template>
    <div>
        <el-dialog title="完成面试" :visible.sync="finishVisible" width="600px" center>
            <el-form ref="finishForm" :rules="finishRules" :model="finishForm" label-width="160px">
                <el-form-item label="面试结果" prop="subStatus">
                    <el-select v-model="finishForm.subStatus" style="width:280px" clearable placeholder="请选择面试结果">
                        <el-option v-for="(item, index) in subStatusList" :key="index" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="finishVisible = false">取 消</el-button>
                <el-button type="primary" plan @click="confFinishForm('finishForm')">确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import moment from "moment";
import workercrmapi from "@/script/api/workercrmapi";
import taskApi from "@/script/api/taskApi";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";

import { validateIdNo } from "@/script/validator";

export default {
    components: {},

    filters: {

    },
    data() {
        return {
            subStatusList: [
                {
                    value: 1,
                    label: '面试通过'
                },
                {
                    value: 2,
                    label: '需再次面试'
                },
                {
                    value: 3,
                    label: '面试淘汰'
                },

            ],
            finishVisible: false,
            interviewId: '',
            finishForm: {
                subStatus: "",
            },
            finishRules: {
                subStatus: [{ required: true, message: "请选择面试结果", trigger: "change" }],
            }
        }
    },
    methods: {
        finishInterview(row) {
            this.interviewId = row.id;
            this.finishVisible = true;
            this.finishForm = {
                subStatus: "",
            };
        },

        confFinishForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = this.finishForm;
                    params.interviewId = this.interviewId;
                    taskApi.$axiosFinishInterview(params).then(res => {
                        console.log(res);
                        if (res.data.errno == 0) {
                            this.$message.success("操作成功");
                            this.finishVisible = false;
                            this.$parent.querySearch();
                        } else {
                            this.$message.warning(res.data.data);
                        }
                    });
                } else {
                    console.log("err");
                }
            });
        },

    }
};
</script>

<style scoped></style>
